import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { completeCustomOfferPaymentIfNeeded } from '../../util/customOfferPaymentCompletion';
import * as log from '../../util/log';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/PaymentConfirmationPage/SET_INITIAL_VALUES';

export const CONFIRM_PAYMENT_REQUEST = 'app/PaymentConfirmationPage/CONFIRM_PAYMENT_REQUEST';
export const CONFIRM_PAYMENT_SUCCESS = 'app/PaymentConfirmationPage/CONFIRM_PAYMENT_SUCCESS';
export const CONFIRM_PAYMENT_ERROR = 'app/PaymentConfirmationPage/CONFIRM_PAYMENT_ERROR';

// ================ Reducer ================ //

const initialState = {
  confirmPaymentInProgress: false,
  confirmPaymentError: null,
};

export default function transactionPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case CONFIRM_PAYMENT_REQUEST:
      return { ...state, confirmPaymentError: null, confirmPaymentInProgress: true };
    case CONFIRM_PAYMENT_SUCCESS:
      return state;
    case CONFIRM_PAYMENT_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, confirmPaymentError: payload, confirmPaymentInProgress: false };
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const transitionInProgress = state => {
  return state.TransactionPage.transitionInProgress;
};

// ================ Action creators ================ //

const confirmPaymentRequest = () => ({ type: CONFIRM_PAYMENT_REQUEST });
const confirmPaymentSuccess = orderId => ({
  type: CONFIRM_PAYMENT_SUCCESS,
  payload: orderId,
});
const confirmPaymentError = e => ({
  type: CONFIRM_PAYMENT_ERROR,
  error: true,
  payload: e,
});

// ================ Selectors ================ //

// ================ Thunks ================ //

export const confirmPayment = (
  transactionId,
  transitionName,
  transitionParams = {},
  config
) => async (dispatch, getState, sdk) => {
  dispatch(confirmPaymentRequest());

  const bodyParams = {
    id: transactionId,
    transition: transitionName,
    params: transitionParams,
  };
  const queryParams = {
    include: ['booking', 'provider'],
    expand: true,
  };
  return sdk.transactions
    .transition(bodyParams, queryParams)
    .then(async response => {
      const order = response.data.data;
      dispatch(confirmPaymentSuccess(order.id));
      await completeCustomOfferPaymentIfNeeded({ order, transactionId, transitionName });
      dispatch(addMarketplaceEntities(response));
      return order;
    })
    .catch(e => {
      dispatch(confirmPaymentError(storableError(e)));
      const transactionIdMaybe = transactionId ? { transactionId: transactionId.uuid } : {};
      log.error(e, 'initiate-order-failed', {
        ...transactionIdMaybe,
      });
      throw e;
    });
};
